export default __webpack_public_path__ + "static/media/three.9666cb79.jpg";